import { Ref } from 'vue';

export interface SEOConfig {
    defaultTitle?: string;
    titleTemplate?: string | ((title: string) => string);
    defaultDescription?: string;
    defaultOgImage?: string;
    defaultKeywords?: string[];
    fallbackLanguage?: string;
    host?: string;
    autoRobots?: boolean; // Automatically set robots based on environment
    titlePrefix?: string; // Prefix for titles (e.g., "Donatos Pizza — ")
    fallbackKeywords?: string; // Default keywords when none provided
    store?: any; // Vuex store instance
}

export interface MetaTag {
    name?: string;
    property?: string;
    content: string;
    httpEquiv?: string;
}

export interface SEOOptions {
    title?: string | Ref<string>;
    description?: string | Ref<string>;
    keywords?: string | string[] | Ref<string | string[]>;
    ogImage?: string | Ref<string>;
    ogType?: string;
    ogTitle?: string | Ref<string>;
    ogDescription?: string | Ref<string>;
    ogUrl?: string;
    publishTime?: string | Date; // For og:published_time
    twitterCard?: 'summary' | 'summary_large_image' | 'player' | 'app';
    twitterTitle?: string;
    twitterDescription?: string;
    twitterImage?: string;
    twitterSite?: string;
    twitterCreator?: string;
    canonical?: string | Ref<string>;
    robots?: string;
    jsonLd?: Record<string, any> | Record<string, any>[] | Ref<Record<string, any> | Record<string, any>[]>;
}

export interface StructuredData {
    '@context'?: string;
    '@type'?: string;
    [key: string]: any;
}

export interface SEORouteConfig {
    title?: string | ((route: any) => string);
    description?: string | ((route: any) => string);
    keywords?: string | string[];
    ogImage?: string | ((route: any) => string);
    ogType?: string;
    ogTitle?: string | ((route: any) => string);
    ogDescription?: string | ((route: any) => string);
    ogUrl?: string | ((route: any) => string);
    twitterCard?: 'summary' | 'summary_large_image' | 'player' | 'app';
    twitterTitle?: string | ((route: any) => string);
    twitterDescription?: string | ((route: any) => string);
    twitterImage?: string | ((route: any) => string);
    twitterSite?: string;
    twitterCreator?: string;
    canonical?: string | ((route: any) => string);
    robots?: string;
    structuredData?: StructuredData | StructuredData[] | ((route: any) => StructuredData | StructuredData[]);
    inheritFromParent?: boolean;
}
